import { WidgetId } from 'types/idTypes';
import { ReadOnlyWidgetBase, WidgetBase, WidgetBaseProp, useGroupIdCache, useWidget } from 'widgets/sdk';

import { ResponsiveWidgetBaseData } from './ResponsiveWidgetBase.types';
import { ResponsiveWidgetProvider } from './useResponsiveWidget';

interface ResponsiveWidgetBaseProps extends WidgetBaseProp {
  // Array of widget ids in the order that they are rendered
  // Used to set up the GroupIdCache so that the BB selection states are correct.
  widgetIdRenderOrder: WidgetId[];

  fitWidthWidgets?: WidgetId[];
  fitHeightWidgets?: WidgetId[];
  isFitContentWidth?: boolean;
}

export const ResponsiveWidgetBase = ({
  children,
  widgetIdRenderOrder,
  fitWidthWidgets,
  fitHeightWidgets,
  isFitContentWidth = false,
  ...widgetBaseProps
}: ResponsiveWidgetBaseProps) => {
  const { widgetId } = useWidget<ResponsiveWidgetBaseData>();

  useGroupIdCache(widgetId, widgetIdRenderOrder, true, widgetIdRenderOrder.length);

  return (
    <WidgetBase isResponsiveWidgetBase isFitContentWidth={isFitContentWidth} {...widgetBaseProps}>
      <ResponsiveWidgetProvider
        responsiveWidgetId={widgetId}
        fitWidthWidgets={fitWidthWidgets}
        fitHeightWidgets={fitHeightWidgets}
      >
        {children}
      </ResponsiveWidgetProvider>
    </WidgetBase>
  );
};

export const ReadOnlyResponsiveWidgetBase = ({ children }: WidgetBaseProp) => {
  const { widgetId } = useWidget<ResponsiveWidgetBaseData>();

  return (
    <ReadOnlyWidgetBase isResponsiveWidgetBase>
      <ResponsiveWidgetProvider responsiveWidgetId={widgetId}>{children}</ResponsiveWidgetProvider>
    </ReadOnlyWidgetBase>
  );
};
